// @flow
import styles from './Tier.less';

import React from 'react';

import FormattedMessage from '../../FormattedMessage/FormattedMessage';
import SearchResultList from '../../SearchResultList/SearchResultList';

type Props = {
  tierNumber: number,
  header: ?SearchResultViewModelTierHeader,
  jobs: Array<SearchResultJob>
};

export default ({ tierNumber, header, jobs }: Props) => (
  <div>
    {header && header.parts ? (
      <h1
        className={
          header.isDivider ? styles.dividerHeader : styles.standardHeader
        }
        data-automation={`tier${tierNumber}header`}
      >
        <FormattedMessage message={header} />
      </h1>
    ) : null}
    <SearchResultList jobs={jobs} />
  </div>
);
